"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const HelpIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({}, props, { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M10.1857 15.5H13.0714C12.6714 11.8159 17 11.3176 17 7.69064C17 4.57772 14.8144 2.74915 11.8429 2.74915C9.70007 2.74915 8.25714 3.60673 7 5.06324L8.90007 6.89099C9.72864 5.97711 10.6715 5.40593 11.8429 5.40593C13.3001 5.40593 14.1572 6.31981 14.1572 7.69064C14.1572 10.261 9.58571 11.3304 10.1857 15.5Z", fill: color !== null && color !== void 0 ? color : theme.colors.white }), (0, jsx_runtime_1.jsx)("path", { d: "M13.3236 19.3364C13.3236 20.2552 12.5774 21 11.6569 21C10.7364 21 9.99023 20.2552 9.99023 19.3364C9.99023 18.4176 10.7364 17.6727 11.6569 17.6727C12.5774 17.6727 13.3236 18.4176 13.3236 19.3364Z", fill: color !== null && color !== void 0 ? color : theme.colors.white })] })));
};
exports.HelpIcon = HelpIcon;
//# sourceMappingURL=help_icon.js.map